import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { ManejadorDeErroresService } from '../sistema/manejador-de-errores.service';

@Injectable({
  providedIn: 'root'
})
export class LocalDataService {

  constructor(
    private storage: Storage,
    private manejadorDeErroresService: ManejadorDeErroresService,

  ) { }

  public eliminarLlave(strKey: string): Promise<boolean> {
    const promesa = new Promise<boolean>((resolve, reject) => {
      this.storage.ready().then(async () => {
        // borrar del storage
        await this.storage.remove(strKey);
        resolve(true);
      }, (error) => {
        this.manejadorDeErroresService.manejadorErroresNotificacion(error);
        resolve(false);
      }).catch(error => {
        this.manejadorDeErroresService.manejadorErroresNotificacion(error);
        resolve(false);
      });
    });
    return promesa;
  }

  public guardarLlave(strKey: string, objValue: any): Promise<boolean> {
    const promesa = new Promise<boolean>((resolve) => {
      this.storage.ready().then(async () => {
        // guardar en el storage
        const data = await this.storage.set(strKey, objValue);
        resolve(true);
      }, (error) => {
        this.manejadorDeErroresService.manejadorErroresNotificacion(error);
        resolve(false);
      }).catch(error => {
        this.manejadorDeErroresService.manejadorErroresNotificacion(error);
        resolve(false);
      });
    });
    return promesa;
  }

  public consultarLlave<T>(strKey: string): Promise<T> {
    const promesa = new Promise<T>((resolve) => {
      this.storage.ready()
        .then(async () => {
          // leer del storage
          const data = await this.storage.get(strKey);
          resolve(data);
        }, (error) => {
          this.manejadorDeErroresService.manejadorErroresNotificacion(error);
          resolve(undefined);
        }).catch(error => {
          this.manejadorDeErroresService.manejadorErroresNotificacion(error);
          resolve(undefined);
        });
    });
    return promesa;
  }


  public async boorrarLlavesLogOut() {

    await this.eliminarLlave('passCard');
    await this.eliminarLlave('DataInventario');
    await this.eliminarLlave('DataInventarioAgrupado');
    await this.eliminarLlave('filtroInventario');
    await this.eliminarLlave('objFiltroTareasPendientes');

  }


}
